export const NEXT_PUBLIC_APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? "http://localhost:3000";

export const NEXTAUTH_SECRET = "Rz+lZAucXN0QF8KDhy2NpfPlmLwtwv+3Pb5/YHy8Hbw=";

export const INVITATION_CODE = "LUXUS2025";

// twitter
// fWgntU4c3ddxMNknSnhsi8Nmo
// 283OEJFwfUMLb6BUOAT2Q2hUnM5tH3I1qlqHH8xxMEqGsPziy7
// AAAAAAAAAAAAAAAAAAAAABnmzgEAAAAA%2B9eG7AjC68vTHqHMbWWh0ConSlQ%3DNAhH2lrVDbHRPvANBBsZdWtgdgbKgivMnVNmCmFtOTpeaDnY34
// twitter oauth2
// SHdBZzVwRXlXc0I5LVVJMVgzT186MTpjaQ
// vnGRC1OY4sHUAaVYAPTqJF_Cu1DWfIGeWw3G8f6wBGuIVezvnM
export const ENVIRONMENT: "prod" | "staging" = process.env.NODE_ENV === "production" ? "prod" : "staging";

// stripe listen --forward-to localhost:3001/api/webhooks/stripe
export const SECRETS = {
  STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY || "sk_test_aOpviWgSDWMlQK7kKQ5GDL4n00LrbxNVrc",
  STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET || "whsec_0df073787709ac1a48cc21ae378871227f00faa7582050ba94863de15358b5ad",
  OPENAI_API_KEY: process.env.OPENAI_API_KEY || "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",
  ANTHROPIC_API_KEY: process.env.ANTHROPIC_API_KEY || "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",
  ZITADEL_ISSUER: process.env.ZITADEL_ISSUER || "id.atha.gr",
  ZITADEL_CLIENT_ID: process.env.ZITADEL_CLIENT_ID || "310154398279992823",
  ZITADEL_CLIENT_SECRET: process.env.ZITADEL_CLIENT_SECRET || "CbVgYEwLyViDM7RYTaKh43f6oieh8sPfrFJ6a2TRwX0T6OW3SsBFYkRSahhZNBWc",
  ZITADEL_ORG_SCOPE: process.env.ZITADEL_ORG_SCIPE ||"urn:zitadel:iam:org:id:292443623809615144",
  SLACK_WEBHOOK_URL: process.env.SLACK_WEBHOOK_URL || "https://hooks.slack.com/services/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",
}

function assertEnv(key: string) {
  if (!process.env[key]) {
    throw new Error(`missing env.${key}`);
  }
}

// assertEnv("FACEBOOK_APP_ID");
// assertEnv("FACEBOOK_APP_SECRET");

export const FACEBOOK = {
  APP_ID: process.env["FACEBOOK_APP_ID"],
  APP_SECRET: process.env["FACEBOOK_APP_SECRET"],
  REDIRECT_URI: `${NEXT_PUBLIC_APP_URL}/api/link/facebook/callback`,
  AUTH_URL: "https://www.facebook.com/v22.0/dialog/oauth",
  TOKEN_URL: "https://graph.facebook.com/v22.0/oauth/access_token",
};

export function isProduction(): boolean {
  return process.env.NODE_ENV === "production";
}
